<template>
  <div class="popup" v-show="taskSingleShow" v-cloak id="syncTaskSingle">
    <div id="pleaseSelect" class="content">
      <div class="title">
        <span>{{$t('language.popup.cloudTransferPopup.pleaSelect')}}</span>
        <div class="icon white-close dialog-close" @click="closeTaskSigle()"></div>
      </div>
      <div class="task-content" v-loading='loading' ref="sourceTree">
        <el-scrollbar style="height:100%;" ref="elscrollbar">
           <div v-if="!model.length&&!loading" class='real-nodrives'  @click="toAddCloudPage()">
               <div class="nondrive-realtime"></div>
               <div class="nondrive-realtimedes" v-if="realTimeMode">
                    {{$t('language.cloudSync.addRealDrives')}}
               </div>
               <div class="nondrive-realtimedes" v-else>
                    {{$t('language.popup.cloudTransferPopup.addValidCloud')}}
               </div>
           </div>

          <div class="tree-nodes" id="treeNodes">
            <ul :key="index" v-for="(item,index) in model">
              <tree ref="tree" :model="item" :index="index" :treeShow=false :transferAimFlag=false></tree>
            </ul>
          </div>
        </el-scrollbar>
      </div>
      <div class="task-footer">
        <button class="task-button" @click="singleSubmit()">{{$t('language.common.ok')}}</button>
      </div>
    </div>
  </div>
</template>

<script>
import commonUtils from "@/js/workspace/common_util.js";
import tree from "@/components/common/trees/tree";
import taskTransferUtils from '@/js/workspace/task_transfer_util.js';
import commonstate from '@/js/constant.js';
export default {
  data: function () {
    return {
      taskSingleShow: false,
      model: [],
      checkedNodes: '',
      loading: true,
      flag: true,
      scrollTopValue: 0,
      realTimeMode:false
    };
  },
  mounted () {
    this.$store.commit('setClickItem', null);
    this.$store.commit('setArr', -1);
    let that = this;
    let models = Object.assign([], this.$store.getters.getUsersDrives).filter(cloud => !commonstate.emailClouds.includes(cloud.driveType));
    if (!models.length && that.$route.name == 'cloudSync') {
      this.model = this.Utils.getAllCloudsList(function (res) {
        if (res.status == 200) {
          that.loading = false;
        }
      }).filter(cloud => !commonstate.emailClouds.includes(cloud.driveType));
    } else {
      this.model = models;
      this.loading = false;
    }
    $.each(this.model, function (index, item) {
      if (item.children && item.children.length) {
        item.open = false;
        delete item.children;
      }
    });
  },
  watch:{
      taskSingleShow(newValue,oldValue){
        if(this.realTimeMode){
    //          let supportsRealTimeArr =commonUtils.getRealTimeModel();
    //          this.model = supportsRealTimeArr;
              this.$store.state.treeRealTimeMode = true;
        }else{
             this.model = Object.assign([], this.$store.getters.getUsersDrives).filter(cloud => !commonstate.emailClouds.includes(cloud.driveType));
              this.$store.state.treeRealTimeMode = false;
       }
      }

  },
  methods: {
    closeTaskSigle () {
      this.taskSingleShow = false;
      if (!this.$store.state.clickItem || !this.$parent.singleDrives.name) {
        $.each(this.model, function (index, item) {
          item.open = false;
          if (item.children && item.children.length) {
            commonUtils.closeTree(item.children);
          }
        });
        this.$forceUpdate();
        this.scrollTopValue = 0;
      }
    },
    toAddCloudPage () {
      let dom;
      let that = this;
      $.each(that.$parent.$parent.$children, function (i, item) {
        if (item.menuOptions) {
          dom = that.$parent.$parent.$children[i];
          dom.menuOptionSelect(10);
          return;
        }
      });
    },
    getFilePath (json, nodes) {
      node = null;
      if (nodes == null) return "";
      let fileName = nodes.name;
      var res = this.getNode(json, nodes.id);
      var pNode = res.parentNode;
      if (pNode != null) {
        if (pNode.name != null && pNode != undefined) {
          fileName = this.getFilePath(json, pNode) + "/" + fileName;
        }
      }
      return fileName;
    },
    singleSubmit () {
      let node = this.$store.state.clickItem;
      let that = this;
      let sourceCatalogArr = [];
      let pKey;

      if (node) {
        let type = node.driveType;
        let pathArray = taskTransferUtils.findFilePathArray(this.model, node, []);
        let path = pathArray[0];
        for (let i = 1; i < pathArray.length; i++) {
          path = path + '\\' + pathArray[i];
        }
        node.driveType = type;
        node.cloudCatalog = path;
        if (this.$parent.mulitDrives.length) {
          if (node.driveId) {
            pKey = node.driveId + node.id + node.formUrl;
          } else if (node.rootId) {
            pKey = node.id + node.rootId + node.name;
          }
          sourceCatalogArr.push(pKey);
          $.each(this.$parent.mulitDrives, function (index, item) {
            that.flag = taskTransferUtils.checkCatalog(sourceCatalogArr, item);
            if (that.flag == false) {
              that.$toast({
                text: that.$t('language.exception.notBeTheSame'),
                type: 'fail',
                idValue: "syncTaskSingle",
                learnMoreShow: true
              });
              return false;
            }
          });
        }
        if (this.flag) {
          this.checkedNodes = node;
          this.$parent.singleDrives = node;
          this.$parent.hasSelect = false;
          this.taskSingleShow = false;
          if (!path) {
            this.$parent.hasSelect = true;
          }
        }
      }
      this.scrollTopValue = this.$refs.sourceTree.scrollTop;
      this.$refs.sourceTree.scrollTop = 0;
    },
  },
  components: {
    tree
  }
};
</script>

<style>
.el-scrollbar .el-scrollbar__wrap {
  overflow-x: hidden;
}
.realTime-title{
    height: 30Px;
    width: 100%;
    line-height: 30Px;
    margin-top: 10Px;
    box-sizing: border-box;
    padding-left: 20Px;
    color: #6f7886;
    font-size: 14Px;
}

</style>



// WEBPACK FOOTER //
// src/components/popup/cloud_transfer_popups/sync_single_popup.vue